
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Slightly Smiling Face","xmlns":"http://www.w3.org/2000/svg","width":"28.04","height":"28.04","viewBox":"0 0 28.04 28.04"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"data-name":"Ellipse 6566","cx":"14.02","cy":"14.02","fill":"#fdca47","r":"14.02"}}),_c('path',{attrs:{"d":"M19.307 18.128a.392.392 0 01.591.47 6.885 6.885 0 01-11.763 0 .392.392 0 01.591-.47 10.135 10.135 0 0010.58 0z","fill":"#664100"}}),_c('g',{attrs:{"transform":"translate(7.437 7.827)","fill":"#664100"}},[_c('ellipse',{attrs:{"data-name":"Ellipse 6567","cx":"1.878","cy":"2.73","rx":"1.878","ry":"2.73","transform":"translate(9.409)"}}),_c('ellipse',{attrs:{"data-name":"Ellipse 6568","cx":"1.878","cy":"2.73","rx":"1.878","ry":"2.73"}})])])
          )
        }
      }
    